import { dmApi } from "../../../app/dmApi";
import {
  getAuthorizationHeader,
  handleQueryError,
  handleQueryErrorAndSuccess,
} from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";

export const pastingSortingApi = dmApi.injectEndpoints({
  endpoints: (build) => ({
    createPastingSorting: build.mutation({
      query: (requestBody) => ({
        url: `/pasting/add-sorting-record`,
        method: "POST",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["pastingSorting", "pastingSortingSummary"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Record");
      },
    }),

    updatePastingSorting: build.mutation({
      query: ({ id, requestBody }) => ({
        url: `/pasting/update-sorting-record/${id}`,
        method: "PUT",
        headers: getAuthorizationHeader(),
        body: requestBody,
      }),
      invalidatesTags: ["pastingSorting", "pastingSortingSummary"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Record");
      },
    }),

    getPastingSorting: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/pasting/sorting-record-list?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["pastingSorting"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),

    getPastingSortingSummary: build.query({
      query: (data) => {
        const paramData = serialize(data);
        return {
          url: `/pasting-data/sorting/summary?${paramData}`,
          method: "GET",
          headers: getAuthorizationHeader(),
        };
      },
      providesTags: ["pastingSortingSummary"],
      async onQueryStarted(_, { queryFulfilled }) {
        await handleQueryError(queryFulfilled);
      },
    }),
  }),
});

export const {
  useCreatePastingSortingMutation,
  useUpdatePastingSortingMutation,
  useGetPastingSortingQuery,
  useGetPastingSortingSummaryQuery,
} = pastingSortingApi;
